import HeartCalender from "./HeartCalender";
import CircleIcon from "./CircleIcon";
import LocationIcon from "./LocationIcon";
import Cross from "./Cross";
import Arrow from "./Arrow";
import StarIcon from "./StarIcon";
import DotIcon from "./DotIcon";
import WhiteCross from "./WhiteCross";
import ShareIcon from "./ShareIcon";
import BackArrow from "./BackArrow";
import BigStar from "./BigStar";
import MuteIcon from "./MuteIcon";
import UnmuteIcon from "./UnmuteIcon";
import CalendarIcon from "./CalendarIcon";
import ClockIcon from "./ClockIcon";
import Drinks from "./Drinks";
import Massage from "./Massage";
import Food from "./Food";
import WayLine from "./WayLine";
import SparkFav from "./SparkFav";
import WhatsappIcon from "./WhatsappIcon";
import MainExperienceScreenIcon from "./MainScreenIcon";

const ExperienceIcons = {
  HeartCalender,
  SparkFav,
  Drinks,
  WayLine,
  CircleIcon,
  CalendarIcon,
  Food,
  UnmuteIcon,
  MuteIcon,
  ClockIcon,
  Cross,
  LocationIcon,
  Arrow,
  StarIcon,
  DotIcon,
  WhiteCross,
  ShareIcon,
  BackArrow,
  BigStar,
  Massage,
  WhatsappIcon,
  MainExperienceScreenIcon
};

export default ExperienceIcons;
